<template>
    <div>
        <el-row :gutter="24" :data="infoData">
            <el-col :span="7">
                <div class="grid-content bg-purple">
                    <div class="label">
                        分公司：
                        <span class="value" :title="infoData.companyName">{{infoData.companyName}}</span>
                    </div>
                    <div class="label">
                        服务平台：
                        <span class="value" :title="infoData.siteName">{{infoData.siteName}}</span>
                    </div>
                    <div class="label">
                        会计主体：
                        <span class="value" :title="infoData.ledgerName">{{infoData.ledgerName}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="grid-content bg-purple">
                    <div class="label">
                        业务类型：
                        <span class="value" :title="infoData.businessType">
                            {{infoData.businessType}}
                        </span>
                    </div>
                    <div class="label">
                        任务类型：
                        <span class="value" :title="infoData.feeTaskType">
                            {{infoData.feeTaskType}}
                        </span>
                    </div>
                    <div class="label">
                        不含税总金额：
                        <span class="value" :title="infoData.noTaxAmount">{{infoData.noTaxAmount}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="5">
                <div class="grid-content bg-purple">
                    <div class="label">
                        含税总金额：
                        <span class="value" :title="infoData.amount" >{{infoData.amount}}</span>
                    </div>
                    <div class="label">
                        税额：
                        <span class="value" :title="infoData.taxAmount" >{{infoData.taxAmount}}</span>
                    </div>
                    <div class="label">
                        备注：
                        <span class="value" :title="infoData.remark">{{infoData.remark}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="big-money">
                    <div class="money-head">
                        <span class="money">{{infoData.supplierComfirmAmount ? infoData.supplierComfirmAmount : 0}}</span>  <span class="text">元</span>
                    </div>
                    <div class="text">确认金额</div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: {
        infoData: {
            type: Object
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="less">
</style>